import React, { useEffect, useState } from 'react'
import {toast} from "react-toastify";
import Hero from '../components/Hero'
import TextSection from '../components/TextSection'
import { FaSearch } from "react-icons/fa";
import RegionData from '../data/RegionData'
import WagesData from "../data/WagesData.jsx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import CountryAddressData from '../data/CountryAddressData.jsx';

import { textsection_fourcontractor } from '../data/TextsectionData.jsx';

const Contractors = () => {
  const [region,setRegion] = useState([]);
  const [wages,setWages] = useState([]);

  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const ITEMS_PER_PAGE = 8;

  const loadRegionData = () => {
    try {
      if (RegionData.actionMsg === 1) {
        setRegion(RegionData.regionlist);
      } else {
        toast.error(`${RegionData.Message}`, { duration: 1000 });
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`, { duration: 1000 });
    }
  };
  const getwages = () => {
    try {
      const res = WagesData; // Use static data
      if (res.actionMsg === 1) {
        setWages(res.wagesdata);
      } else {
        toast.error(`${res.Message}`, { duration: 1000 });
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`, { duration: 1000 });
    }
  };
  useEffect(()=>{
    loadRegionData();
    getwages();
  

  },[])

  // Filter the country data based on the search term
  const filtered = wages.filter((data) => {
    const matchesSearch = data.country_name.toLowerCase().includes(searchTerm.toLowerCase()) || data.region_name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesRegion = selectedRegion ? data.region_id === selectedRegion : true; // Filter by selected region
    return matchesSearch && matchesRegion;
  });

  const handleWages = (region_id) => {
    if (region_id === 'showall') {
      setSelectedRegion(null); 
    } else {
      setSelectedRegion(region_id);
    }
    setCurrentPage(1); 
  };

  // Pagination logic
  const indexOfLast = currentPage * ITEMS_PER_PAGE;
  const indexOfFirst = indexOfLast - ITEMS_PER_PAGE;
  const currentData = filtered.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const getCountryDetails = (countryName) => {
    const countryBranches = [];

    // Loop through CountryAddressData to find branches for the country
    for (let dataArray of CountryAddressData) {
      // Filter the branches that match the country name
      const countryData = dataArray.filter(item => item.country.toLowerCase() === countryName.toLowerCase());
      
      // If branches are found, add them to the array
      if (countryData.length > 0) {
        countryBranches.push(...countryData); // Add matching branches to the array
      }
    }

    return countryBranches; // Return the filtered branches for the country
  };
  return (
    <>
     <Hero
      title="Connect with our contractor support team."
      description=""
      buttonText=""
      customClass="contractorBanner"
      imageSrc="images/hero.jpg"
      squareColor="Contractorsquare-bg-color"
    />
     <TextSection  data={textsection_fourcontractor} withSpan={false}/>

       <div className="cwrapper">
             <div className="container">
               <div className="cheader_section">
                 <div className="cheader_data">
                   <div className="cheader_list">
                     <ul>
                       <li>
                         <div className="cheader_content" onClick={() => handleWages('showall')}>
                         <div className="cheader_img">
                               <img src="/images/viewall.png" alt="viewall" className="img-fluid removeStyle"/>
                             </div>
                           <div className="cheader_title">
                             <span>View all</span>
                           </div>
                         </div>
                       </li>
                     {
                       region?.map((item,index)=>(
                         <li key={index}>
                           <div className="cheader_content" onClick={() => handleWages(item.id)}>
                             <div className="cheader_img">
                               <img src={item.image} alt={item.name} className="img-fluid" />
                             </div>
                             <div className="cheader_title">
                               <span>{item.name}</span>
                             </div>
                           </div>
                         </li>
                       ))
                     }
                     </ul>
                   </div>
                 </div>
               </div>
               <div className="body_tsection contactAddress">
                 <div className="body_tdata">
                   <div className="body_scontent">
                     <div className="row ps-2 mb-4 mt-2">
                       <div className="col-lg-3">&nbsp;</div>
                       <div className="col-lg-6">
                         <div className="input_section">
                           <div className="form_ricon_group" style={{alignItems:'center'}}>
                             <input
                               type="text"
                               placeholder="Search by country or region"
                               onChange={handleSearchChange}
                             />
                             <span><FaSearch /></span>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                   <div className="body_tcontent">
                     <div className="row g-3">
                       {currentData.length > 0 ? (
                         currentData.map((item, index) => {
                           // Get address and phone based on country
                           const countryDetails = getCountryDetails(item.country_name);
                           const { address, phone, companyname ,contact } = countryDetails;
                           return (
                             <>
                             {countryDetails.map((branch, branchIndex) => {
                               const { location, companyname, address, phone, contact } = branch;
                               return (
                             <div className="col-lg-4" key={index}>
                               <div className="hcard_section">
                                 <div className="hcard_image">
                                 {location === "Coimbatore" ? (
                                   <img src="images/d_coimbatore.jpg" alt="Coimbatore" className="img-fluid" />
                                 ) : location === "Noida" ? (
                                   <img src="images/noida.jpg" alt="Noida" className="img-fluid" />
                                 ) : (
                                   <img src={item.imageUrl} alt={item.title} className="img-fluid" />
                                 )}
                                   
                                 </div>
                                 <div className="hcard_bsection">
                                   <div className="hcard_tsection">
                                   <p>{item.title} {location ? `- ${location}` : ''}</p> {/* Conditionally display location */}
                                   </div>
                                   <div className="hcard_subsection">
                                     <div className="contact_address">
                                       <p className="company_name">{companyname || 'Company Name'}</p>
                                       <p className="company_address">{address || ''}</p>
                                       <p className="company_phone">
                                         <FontAwesomeIcon icon={faPhone} className="icon phone-icon" />
                                         <span>{phone || '99 969 999 125'}</span>
                                       </p>
                                       <p className="company_email">
                                         <FontAwesomeIcon icon={faEnvelope} className="icon email-icon" />
                                         <span>{contact || 'contact@ampstek.com'}</span>
                                       </p>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                             </div>
                              );
                             })}
                           </>    
                           );
                         })
                       ) : (
                         <p className="msgtext">No Countries were found.</p>
                       )}
                     </div>
                   </div>
                   <div className="body_psection">
                     <div className="pagination">
                       <button onClick={() => handlePageChange(1)} disabled={currentPage === 1}>First</button>
                       <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Prev</button>
                       <span>Page {currentPage} of {totalPages}</span>
                       <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                         Next
                       </button>
                       <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>Last</button>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>
    </>
   
  )
}

export default Contractors